import React from 'react';
import { Menu } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Link, useRouteMatch } from 'react-router-dom';
import { useQueryClient } from 'react-query';

// Import styles
import {
	ButtonStyled,
	MenuStyled,
	LogoutItem,
	ButtonLogout,
	ButtonsContainer,
	ButtonText
} from './styles';
import { ItemStyled } from 'components/elements/molecules/dropdown/styles';

// Import utilities
import { useAuth } from 'components/utilities';

// Import actions
import { signOut } from 'store/actions';

// Import variables
import { filterOperatorLinks } from 'helpers/operators';
import { ROUTES_CORE_PATHS } from 'helpers/variables';

// Import routes
import { NAV_LINKS } from 'components/routes/user_routes/routes';

const filteredLinks = NAV_LINKS.filter(filterOperatorLinks);
const { LOGIN, REGISTER, CONFIGURATOR, EMAIL_CONFIRMATION } = ROUTES_CORE_PATHS;

export const useNavDropdown = ({ isMobile, isOpen, toggle }) => {
	const { t } = useTranslation();
	const dispatch = useDispatch();
	const { isAuth } = useAuth();
	const queryClient = useQueryClient();
	const login = useSelector(({ auth }) => auth.authenticate?.login || '');

	const handleSignOut = () => {
		queryClient.clear();
		signOut()(dispatch);
	};

	const handleDropdownClick = () => {
		isMobile && isOpen && toggle();
	};

	const match = useRouteMatch([
		`/${CONFIGURATOR}`,
		`/${CONFIGURATOR}/sukces`,
		`/${EMAIL_CONFIRMATION}/:hash`
	]);

	const menu = (
		<MenuStyled isMobile={isMobile}>
			{filteredLinks.map(({ path, translation, key }) => (
				<ItemStyled key={key} isMobile={isMobile}>
					<NavLink to={path} activeClassName="active-drop-nav">
						{t(`user_profile_${translation}`)}
					</NavLink>
				</ItemStyled>
			))}
			<Menu.Divider />
			<LogoutItem key="wyloguj">
				<ButtonLogout onClick={handleSignOut} isMobile={isMobile}>
					{t('common_static_btn_sign_out')}
				</ButtonLogout>
			</LogoutItem>
		</MenuStyled>
	);

	const authButtons = (
		<ButtonsContainer isMobile={isMobile}>
			<ButtonStyled
				as={Link}
				to={{
					pathname: `/${LOGIN}`,
					state: { redirectTo: match ? `/${CONFIGURATOR}` : null }
				}}
				modifiers="reject"
			>
				<ButtonText>{t('login_already_have_an_account')}</ButtonText>
			</ButtonStyled>

			<ButtonStyled as={Link} to={`/${REGISTER}`} modifiers="primaryVod">
				<ButtonText>{t('common_main_nav_register_button')}</ButtonText>
			</ButtonStyled>
		</ButtonsContainer>
	);

	const unauthorizedMenu = (
		<MenuStyled isMobile={isMobile}>{authButtons}</MenuStyled>
	);

	return {
		menu,
		unauthorizedMenu,
		authButtons,
		login,
		isAuth,
		handleDropdownClick
	};
};
